const moduleNameKey = "machineGroupExpandedView";

export const machineGroupExpandedViewEn = {
  [moduleNameKey]: {
    noMachinesAdded: "No Machines Added",
    ticketRoutingPath: "Ticket Routing Path",
    addBot: "Add Bot",
    addFactory: "Add Factory",
    addDistributor: "Add Distributor",
    addOem: "Add OEM",
    addSupplier: "Add Supplier",
    saveRoutingPath: "Save",
    errorCreatingRoutingPath: "Failed to create routing path",
    errorUpdatingRoutingPath: "Failed to update routing path",
    routingPathCreatedSuccessfully: "Ticket routing path created successfully",
    routingPathUpdatedSuccessfully: "Ticket routing path updated successfully",
    routingStageEnableTooltip: "Click on dot to enable this step.",
    routingStageBeforeStartTooltip:
      "Steps before the starting point cannot be modified.",
    routingPathUnchangedTooltip:
      "Make a change to the routing path before saving.",
    selectOrganizationsForActiveRoutingStages:
      "Select an organization for each active routing step before saving:",
    failedToFetchOrganizations: "Failed to fetch organizations",
    activateRoutingStage: "Activate",
    deactivateRoutingStage: "Deactivate",
    factoryRoutingStageAlwaysEnabled: "factory routing stage is always enabled",
    routingStageFixedForOrganization:
      "routing stage is fixed for this organization",
    botOrganizationName: "Things Support",
    routingStage: "routing stage",
    loadingTicketRoutingPath: "Loading ticket routing path",
  },
};

export const machineGroupExpandedViewPtBr = {
  [moduleNameKey]: {
    noMachinesAdded: "Nenhuma máquina adicionada",
    ticketRoutingPath: "Caminho de roteamento de tickets",
    addBot: "Adicionar bot",
    addFactory: "Adicionar fábrica",
    addDistributor: "Adicionar distribuidor",
    addOem: "Adicionar OEM",
    addSupplier: "Adicionar fornecedor",
    saveRoutingPath: "Salvar",
    errorCreatingRoutingPath: "Falha ao criar caminho de roteamento",
    errorUpdatingRoutingPath: "Falha ao atualizar caminho de roteamento",
    routingPathCreatedSuccessfully: "Caminho de roteamento criado com sucesso",
    routingPathUpdatedSuccessfully:
      "Caminho de roteamento atualizado com sucesso",
    routingStageEnableTooltip: "Clique no ponto para ativar esta etapa.",
    routingStageBeforeStartTooltip:
      "Etapas anteriores ao ponto inicial não podem ser modificadas.",
    routingPathUnchangedTooltip:
      "Faça uma alteração no caminho de roteamento antes de salvar.",
    selectOrganizationsForActiveRoutingStages:
      "Selecione uma organização para cada etapa ativa de roteamento antes de salvar:",
    failedToFetchOrganizations: "Falha ao buscar organizações.",
    activateRoutingStage: "Ativar",
    deactivateRoutingStage: "Desativar",
    factoryRoutingStageAlwaysEnabled: "a etapa de fábrica está sempre ativada",
    routingStageFixedForOrganization:
      "a etapa de roteamento está fixa para esta organização",
    botOrganizationName: "Suporte Things",
    routingStage: "etapa de roteamento",
    loadingTicketRoutingPath: "Carregando caminho de roteamento de tickets",
  },
};

export const machineGroupExpandedViewDe = {
  [moduleNameKey]: {
    noMachinesAdded: "Keine Maschinen hinzugefügt",
    ticketRoutingPath: "Ticket-Routing-Pfad",
    addBot: "Bot hinzufügen",
    addFactory: "Fabrik hinzufügen",
    addDistributor: "Distributor hinzufügen",
    addOem: "OEM hinzufügen",
    addSupplier: "Lieferant hinzufügen",
    saveRoutingPath: "Speichern",
    errorCreatingRoutingPath: "Routing-Pfad konnte nicht erstellt werden",
    errorUpdatingRoutingPath: "Routing-Pfad konnte nicht aktualisiert werden",
    routingPathCreatedSuccessfully: "Ticket-Routing-Pfad erfolgreich erstellt",
    routingPathUpdatedSuccessfully:
      "Ticket-Routing-Pfad erfolgreich aktualisiert",
    routingStageEnableTooltip:
      "Klicken Sie auf den Punkt, um diesen Schritt zu aktivieren.",
    routingStageBeforeStartTooltip:
      "Schritte vor dem Startpunkt können nicht geändert werden.",
    routingPathUnchangedTooltip:
      "Ändern Sie den Routing-Pfad, bevor Sie speichern.",
    selectOrganizationsForActiveRoutingStages:
      "Wählen Sie vor dem Speichern für jeden aktiven Routing-Schritt eine Organisation aus:",
    failedToFetchOrganizations:
      "Organisationen konnten nicht abgerufen werden.",
    activateRoutingStage: "Aktivieren",
    deactivateRoutingStage: "Deaktivieren",
    factoryRoutingStageAlwaysEnabled: "Der Fabrikschritt ist immer aktiviert",
    routingStageFixedForOrganization:
      "Routing-Schritt ist für diese Organisation festgelegt",
    botOrganizationName: "Things Support",
    routingStage: "Routing-Schritt",
    loadingTicketRoutingPath: "Ticket-Routing-Pfad wird geladen",
  },
};

export const machineGroupExpandedViewZhHans = {
  [moduleNameKey]: {
    noMachinesAdded: "未添加机器",
    ticketRoutingPath: "工单路由路径",
    addBot: "添加机器人",
    addFactory: "添加工厂",
    addDistributor: "添加分销商",
    addOem: "添加 OEM",
    addSupplier: "添加供应商",
    saveRoutingPath: "保存",
    errorCreatingRoutingPath: "创建路由路径失败",
    errorUpdatingRoutingPath: "更新路由路径失败",
    routingPathCreatedSuccessfully: "工单路由路径已成功创建",
    routingPathUpdatedSuccessfully: "工单路由路径已成功更新",
    routingStageEnableTooltip: "点击圆点以启用此步骤。",
    routingStageBeforeStartTooltip: "起始点之前的步骤无法修改。",
    routingPathUnchangedTooltip: "请先更改路由路径，然后再保存。",
    selectOrganizationsForActiveRoutingStages:
      "保存前，请为每个启用的路由步骤选择一个组织：",
    failedToFetchOrganizations: "获取组织失败。",
    activateRoutingStage: "启用",
    deactivateRoutingStage: "停用",
    factoryRoutingStageAlwaysEnabled: "工厂路由阶段始终启用",
    routingStageFixedForOrganization: "路由阶段已为此组织固定",
    botOrganizationName: "Things 支持",
    routingStage: "路由阶段",
    loadingTicketRoutingPath: "正在加载工单路由路径",
  },
};

export const machineGroupExpandedViewIt = {
  [moduleNameKey]: {
    noMachinesAdded: "Nessuna macchina aggiunta",
    ticketRoutingPath: "Percorso di instradamento dei ticket",
    addBot: "Aggiungi bot",
    addFactory: "Aggiungi fabbrica",
    addDistributor: "Aggiungi distributore",
    addOem: "Aggiungi OEM",
    addSupplier: "Aggiungi fornitore",
    saveRoutingPath: "Salva",
    errorCreatingRoutingPath: "Impossibile creare il percorso di instradamento",
    errorUpdatingRoutingPath:
      "Impossibile aggiornare il percorso di instradamento",
    routingPathCreatedSuccessfully:
      "Percorso di instradamento creato correttamente",
    routingPathUpdatedSuccessfully:
      "Percorso di instradamento aggiornato correttamente",
    routingStageEnableTooltip:
      "Fai clic sul punto per abilitare questo passaggio.",
    routingStageBeforeStartTooltip:
      "I passaggi precedenti al punto iniziale non possono essere modificati.",
    routingPathUnchangedTooltip:
      "Modifica il percorso di instradamento prima di salvare.",
    selectOrganizationsForActiveRoutingStages:
      "Seleziona un'organizzazione per ogni passaggio di instradamento attivo prima di salvare:",
    failedToFetchOrganizations: "Impossibile recuperare le organizzazioni.",
    activateRoutingStage: "Attiva",
    deactivateRoutingStage: "Disattiva",
    factoryRoutingStageAlwaysEnabled: "la fase fabbrica è sempre attiva",
    routingStageFixedForOrganization:
      "fase di instradamento fissa per questa organizzazione",
    botOrganizationName: "Supporto Things",
    routingStage: "fase di instradamento",
    loadingTicketRoutingPath:
      "Caricamento del percorso di instradamento dei ticket",
  },
};

export const machineGroupExpandedViewEs = {
  [moduleNameKey]: {
    noMachinesAdded: "No se añadieron máquinas",
    ticketRoutingPath: "Ruta de enrutamiento de tickets",
    addBot: "Añadir bot",
    addFactory: "Añadir fábrica",
    addDistributor: "Añadir distribuidor",
    addOem: "Añadir OEM",
    addSupplier: "Añadir proveedor",
    saveRoutingPath: "Guardar",
    errorCreatingRoutingPath: "No se pudo crear la ruta de enrutamiento",
    errorUpdatingRoutingPath: "No se pudo actualizar la ruta de enrutamiento",
    routingPathCreatedSuccessfully: "Ruta de enrutamiento creada correctamente",
    routingPathUpdatedSuccessfully:
      "Ruta de enrutamiento actualizada correctamente",
    routingStageEnableTooltip: "Haz clic en el punto para habilitar este paso.",
    routingStageBeforeStartTooltip:
      "Los pasos anteriores al punto de inicio no se pueden modificar.",
    routingPathUnchangedTooltip:
      "Haz un cambio en la ruta de enrutamiento antes de guardar.",
    selectOrganizationsForActiveRoutingStages:
      "Selecciona una organización para cada paso de enrutamiento activo antes de guardar:",
    failedToFetchOrganizations: "No se pudieron obtener las organizaciones.",
    activateRoutingStage: "Activar",
    deactivateRoutingStage: "Desactivar",
    factoryRoutingStageAlwaysEnabled:
      "la etapa de fábrica siempre está activada",
    routingStageFixedForOrganization:
      "etapa de enrutamiento fija para esta organización",
    botOrganizationName: "Soporte de Things",
    routingStage: "etapa de enrutamiento",
    loadingTicketRoutingPath: "Cargando la ruta de enrutamiento de tickets",
  },
};

export const machineGroupExpandedViewNl = {
  [moduleNameKey]: {
    noMachinesAdded: "Geen machines toegevoegd",
    ticketRoutingPath: "Ticketrouteringspad",
    addBot: "Bot toevoegen",
    addFactory: "Fabriek toevoegen",
    addDistributor: "Distributeur toevoegen",
    addOem: "OEM toevoegen",
    addSupplier: "Leverancier toevoegen",
    saveRoutingPath: "Opslaan",
    errorCreatingRoutingPath: "Routeringspad aanmaken is mislukt",
    errorUpdatingRoutingPath: "Routeringspad bijwerken is mislukt",
    routingPathCreatedSuccessfully: "Ticketrouteringspad succesvol aangemaakt",
    routingPathUpdatedSuccessfully: "Ticketrouteringspad succesvol bijgewerkt",
    routingStageEnableTooltip: "Klik op de stip om deze stap in te schakelen.",
    routingStageBeforeStartTooltip:
      "Stappen vóór het startpunt kunnen niet worden gewijzigd.",
    routingPathUnchangedTooltip:
      "Wijzig het routeringspad voordat je het opslaat.",
    selectOrganizationsForActiveRoutingStages:
      "Selecteer een organisatie voor elke actieve routeringsstap voordat je opslaat:",
    failedToFetchOrganizations: "Organisaties ophalen is mislukt.",
    activateRoutingStage: "Activeren",
    deactivateRoutingStage: "Deactiveren",
    factoryRoutingStageAlwaysEnabled: "de fabrieksstap is altijd ingeschakeld",
    routingStageFixedForOrganization:
      "routeringsstap staat vast voor deze organisatie",
    botOrganizationName: "Things Support",
    routingStage: "routeringsstap",
    loadingTicketRoutingPath: "Ticketrouteringspad laden",
  },
};

export const machineGroupExpandedViewTr = {
  [moduleNameKey]: {
    noMachinesAdded: "Makine eklenmedi",
    ticketRoutingPath: "Destek bileti yönlendirme yolu",
    addBot: "Bot Ekle",
    addFactory: "Fabrika Ekle",
    addDistributor: "Distribütör Ekle",
    addOem: "OEM Ekle",
    addSupplier: "Tedarikçi Ekle",
    saveRoutingPath: "Kaydet",
    errorCreatingRoutingPath: "Yönlendirme yolu oluşturulamadı",
    errorUpdatingRoutingPath: "Yönlendirme yolu güncellenemedi",
    routingPathCreatedSuccessfully:
      "Destek bileti yönlendirme yolu başarıyla oluşturuldu",
    routingPathUpdatedSuccessfully:
      "Destek bileti yönlendirme yolu başarıyla güncellendi",
    routingStageEnableTooltip: "Bu adımı etkinleştirmek için noktaya tıklayın.",
    routingStageBeforeStartTooltip:
      "Başlangıç noktasından önceki adımlar değiştirilemez.",
    routingPathUnchangedTooltip:
      "Kaydetmeden önce yönlendirme yolunda bir değişiklik yapın.",
    selectOrganizationsForActiveRoutingStages:
      "Kaydetmeden önce etkin her yönlendirme adımı için bir organizasyon seçin:",
    failedToFetchOrganizations: "Organizasyonlar alınamadı.",
    activateRoutingStage: "Etkinleştir",
    deactivateRoutingStage: "Devre dışı bırak",
    factoryRoutingStageAlwaysEnabled:
      "fabrika yönlendirme adımı her zaman etkindir",
    routingStageFixedForOrganization:
      "yönlendirme adımı bu organizasyon için sabittir",
    botOrganizationName: "Things Desteği",
    routingStage: "yönlendirme adımı",
    loadingTicketRoutingPath: "Destek bileti yönlendirme yolu yükleniyor",
  },
};
